import { PDFPage, rgb } from "pdf-lib";
import { min } from "ramda";
import { ImagePlaceholderOptions } from "./placeholders";
import { DocumentPlaceholder } from "./types";

export const drawErrorBox = (page: PDFPage, placeholder: DocumentPlaceholder<ImagePlaceholderOptions>) => {
  page.drawRectangle({
    x: placeholder.x * page.getSize().width,
    y: page.getSize().height - placeholder.y * page.getSize().height - placeholder.height * page.getSize().height,
    width: placeholder.width * page.getSize().width,
    height: placeholder.height * page.getSize().height,
    borderWidth: 2,
    borderColor: rgb(0.75, 0.2, 0.2),
    borderOpacity: 0.75,
  });

  page.drawRectangle({
    x: placeholder.x * page.getSize().width,
    y: page.getSize().height - placeholder.y * page.getSize().height - placeholder.height * page.getSize().height,
    width: placeholder.width * page.getSize().width,
    height: placeholder.height * page.getSize().height,
    color: rgb(0.75, 0.2, 0.2),
    opacity: 0.2,
  });

  const shorterEdge = min(placeholder.width * page.getSize().width, placeholder.height * page.getSize().height);
  page.drawSvgPath(
    "m40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm302-40q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm-40-120h80v-200h-80v200Zm40-100Z",
    {
      x: placeholder.x * page.getSize().width + (placeholder.width * page.getSize().width) / 2 - shorterEdge / 2,
      y:
        page.getSize().height -
        placeholder.y * page.getSize().height -
        placeholder.height * page.getSize().height +
        (placeholder.height * page.getSize().height) / 2 -
        shorterEdge / 2,
      color: rgb(0.75, 0.2, 0.2),
      scale: shorterEdge / 960,
    }
  );
};

export const drawDebugBox = (page: PDFPage, placeholder: DocumentPlaceholder<ImagePlaceholderOptions>) => {
  page.drawRectangle({
    x: placeholder.x * page.getSize().width,
    y: page.getSize().height - placeholder.y * page.getSize().height - placeholder.height * page.getSize().height,
    width: placeholder.width * page.getSize().width,
    height: placeholder.height * page.getSize().height,
    borderWidth: 2,
    borderColor: rgb(1, 0, 1),
    borderOpacity: 0.75,
  });
};
